import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import DataPackages from "./PackagesData";
import { url } from "../../../Constant";
import axios from "axios";
import { useEffect } from "react";
import { useAuth } from "../../../Context/AuthProvider";

const customStyles = {
  pagination: {
    style: {
      display: "flex",
      justifyContent: "space-between",
    },
  },
};

const columns = [
  {
    name: "PACKAGE",
    selector: "name",
    cell: (row) => <div className="fontColor">{row.name}</div>,
  },
  {
    name: "DESCRIPTION",
    selector: "description",
  },
  {
    name: "GROUPS",
    selector: "no_of_groups",
  },

  {
    name: "EXTENSIONS",
    selector: "no_of_extensions",
  },
  {
    name: "ON-NET MINUTES",
    selector: "voice_minutes_on_net",
  },
  // {
  //   name: "INTL. MINUTES",
  //   selector: "voice_minutes_off_net",
  // },
  // {
  //   name: "DATA LIMIT",
  //   selector: "data_limit",
  // },
  // {
  //   name: "VOICEMAIL LIMIT",
  //   selector: "voice_mail_quota_limit",
  // },
  // {
  //   name: "CALL RECORDING",
  //   selector: "call_recording",
  // },
  // {
  //   name: "CALL RECORDING LIMIT",
  //   selector: "call_recording_quota_limit",
  // },
  // {
  //   name: "PRICE",
  //   selector: "PRICE",
  //   cell: (row) => (
  //     <div>
  //       <b>{row.PRICE}</b>
  //     </div>
  //   ),
  // },
];

const Packages = () => {
  const { auth } = useAuth();
  const [searchText, setSearchText] = useState("");
  const [packages, setPackages] = useState();

  const navigate = useNavigate();

  // const handleEditLayer = (row) => {
  //   // console.log("Row data:", row);
  //   navigate("/edit-layer", { state: { rowData: row } });
  // };

  const getPackage = () => {
    axios
      .post(
        url + "get-packages",
        {},
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          // console.log(response);
          if (response.status === 200) {
            if (response.data.message === "Data Found") {
              setPackages(response?.data?.data?.packages);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    getPackage();
  }, []);

  const handleSearchform = (event) => {
    setSearchText(event.target.value);
  };

  const filteredDataPackages = packages?.filter((PackagesData) => {
    return (
      PackagesData.name &&
      PackagesData.name.toLowerCase().includes(searchText.toLowerCase())
      // || // Corrected selector here
      // (PackagesData.no_of_groups &&
      //   PackagesData.no_of_groups
      //     .toLowerCase()
      //     .includes(searchText.toLowerCase())) ||
      // (PackagesData.no_of_extensions &&
      //   PackagesData.no_of_extensions
      //     .toLowerCase()
      //     .includes(searchText.toLowerCase())) ||
      // (PackagesData.voice_minutes_on_net &&
      //   PackagesData.voice_minutes_on_net.toString().includes(searchText)) ||
      // (PackagesData.voice_minutes_off_net &&
      //   PackagesData.voice_minutes_off_net.toString().includes(searchText)) ||
      // (PackagesData.data_limit &&
      //   PackagesData.data_limit
      //     .toLowerCase()
      //     .includes(searchText.toLowerCase())) ||
      // (PackagesData.voice_mail_quota_limit &&
      //   PackagesData.voice_mail_quota_limit
      //     .toLowerCase()
      //     .includes(searchText.toLowerCase())) ||
      // (PackagesData.call_recording &&
      //   PackagesData.call_recording.toString().includes(searchText)) ||
      // (PackagesData.call_recording_quota_limit &&
      //   PackagesData.call_recording_quota_limit
      //     .toLowerCase()
      //     .includes(searchText.toLowerCase()))
      //   ||
      // (PackagesData.PRICE && PackagesData.PRICE.toString().includes(searchText))
    );
  });

  const handleExportData = () => {
    // console.log("Exporting data...");
    const exportedData = filteredDataPackages?.map((PackagesData) => ({
      PACKAGE: PackagesData.name, // Corrected selector here
      GROUPS: PackagesData.no_of_groups,
      EXTENSIONS: PackagesData.no_of_extensions,
      "ON-NET MINUTES": PackagesData.voice_minutes_off_net,
      DESCRIPTION: PackagesData.description,
      // "INTL. MINUTES": PackagesData.voice_minutes_off_net,
      // "DATA LIMIT": PackagesData.data_limit,
      // "VOICEMAIL LIMIT": PackagesData.voice_mail_quota_limit,
      // "CALL RECORDING": PackagesData.call_recording,
      // "CALL RECORDING LIMIT": PackagesData.call_recording_quota_limit,
      // PRICE: PackagesData.PRICE,
    }));

    const csvContent =
      "data:text/csv;charset=utf-8," + convertToCSV(exportedData);
    const jsonData = JSON.stringify(exportedData, null, 2);

    const downloadLink = document.createElement("a");
    downloadLink.href = csvContent;
    downloadLink.download = "exported_data.csv";
    downloadLink.click();
  };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((item) => Object.values(item).join(","));
    return [header, ...rows].join("\n");
  };

  useEffect(() => {
    if (packages !== undefined) {
      // Target dynamically generated nav for pagination
      const paginationNav = document.querySelector("nav.rdt_Pagination");
      if (paginationNav) {
        // Select the elements for the left group (first span and first div)
        const firstSpanElement = paginationNav.querySelector("span");
        const firstDivElement =
          paginationNav.querySelector("div:first-of-type");

        // Select the elements for the right group (second span and last div)
        const secondSpanElement = paginationNav.querySelector(
          "span:nth-of-type(2)"
        );
        const lastDivElement = paginationNav.querySelector("div:last-of-type");

        // Create a div for the left group
        const leftGroup = document.createElement("div");
        leftGroup.classList.add("left-group"); // Add custom class
        leftGroup.style.display = "flex"; // Apply flex display
        leftGroup.style.alignItems = "center"; // Ensure alignment

        // Create a div for the right group
        const rightGroup = document.createElement("div");
        rightGroup.classList.add("right-group"); // Add custom class
        rightGroup.style.display = "flex"; // Apply flex display
        rightGroup.style.alignItems = "center"; // Ensure alignment
        rightGroup.style.marginLeft = "auto"; // Push to the right side

        // Append the first span and first div into the left group
        if (firstSpanElement && firstDivElement) {
          leftGroup.appendChild(firstSpanElement);
          leftGroup.appendChild(firstDivElement);
        }

        // Append the second span and last div into the right group
        if (secondSpanElement && lastDivElement) {
          rightGroup.appendChild(secondSpanElement);
          rightGroup.appendChild(lastDivElement);
        }

        // Prepend the left group to the pagination nav
        paginationNav.prepend(leftGroup);

        // Check if rightGroup has any children before appending it
        if (rightGroup.childElementCount > 0) {
          paginationNav.appendChild(rightGroup);
        }
      }
    }
  }, [packages]);

  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>

                <p>
                  Use this page to create company, add packages or add master
                  number.
                </p>
              </div>
            </div>

            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                <li onClick={() => navigate("/companies", { replace: true })}>
                  <a href="#">Companies</a>
                </li>
                <li
                  onClick={() => {
                    navigate("/packages", { replace: true });
                  }}
                  className="uk-active"
                >
                  <a href="#">Packages</a>
                </li>
                <li
                  onClick={() => {
                    navigate("/master-number", { replace: true });
                  }}
                >
                  <a href="#">Master number DIOD</a>
                </li>
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            <li></li>
            <li>
              <div className="ImcomingCallMain">
                <div className="uk-grid" uk-grid="">
                  <div className="uk-width-1-2">
                    <div className="uk-text-left">
                      <div className="CustomSearch">
                        <form className="uk-search uk-search-default">
                          <input
                            className="uk-search-input"
                            type="text"
                            placeholder="Search by package name "
                            value={searchText}
                            onChange={handleSearchform}
                          />
                        </form>
                        {/* <div className="MainHeading">
                <h6>IVR flow</h6>
              </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="uk-width-1-2">
                    <div className="uk-text-right">
                      <span>
                        <div className="uk-inline uk-text-left">
                          <Link
                            className="exportData-button NewFlow"
                            to="/add-packages"
                          >
                            Add package
                          </Link>
                          <button
                            className="exportData-button"
                            onClick={handleExportData}
                          >
                            Export Data
                          </button>
                        </div>
                      </span>
                      <span className="primary-color"></span>
                    </div>
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={filteredDataPackages}
                  pagination
                  customStyles={customStyles}
                />
              </div>
            </li>
            <li></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Packages;
